import { render, staticRenderFns } from "./WarrantCalculator.vue?vue&type=template&id=22ec2b8e&scoped=true&"
import script from "./WarrantCalculator.js?vue&type=script&lang=js&"
export * from "./WarrantCalculator.js?vue&type=script&lang=js&"
import style0 from "./WarrantCalculator.vue?vue&type=style&index=0&id=22ec2b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec2b8e",
  null
  
)

export default component.exports